import {
  Button,
  DateInput,
  DropdownOption,
  DropdownSelect,
  FlexBox,
  Modal,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"

import { useFamilyQuery } from "../../../networking/queries"
import { useCustomRewardLogsQuery } from "../../../networking/rewards/queries"
import { FamilyQuerySelect } from "../../../types"
import { useFilterRewardLogsModalStore } from "../hooks/useFilterRewardLogsModalStore"

export default function FilterRewardLogsModal() {
  const [modalSelectedUser, setModalSelectedUser] =
    useState<DropdownOption | null>(null)
  const [modalStartDate, setModalStartDate] = useState<Date | null>(null)
  const [modalEndDate, setModalEndDate] = useState<Date | null>(null)
  const { isOpen, onClose, rewardId, selectedUser, startDate, endDate } =
    useFilterRewardLogsModalStore()
  const { isLoading } = useCustomRewardLogsQuery({ rewardId })
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const { t } = useTranslation()
  const userDropdownOptions =
    children?.map((child) => ({
      label: child.user.name,
      value: child.user.id,
    })) ?? []

  const onApplyFilter = async () => {
    if (
      modalStartDate &&
      modalEndDate &&
      dayjs(modalStartDate)
        .startOf("day")
        .isAfter(dayjs(modalEndDate).startOf("day"))
    ) {
      toast.error(t("FRLM_ERR_DATE"))
      return
    }
    useFilterRewardLogsModalStore.setState({
      selectedUser: modalSelectedUser,
      startDate: modalStartDate,
      endDate: modalEndDate,
    })
    onClose()
  }

  useEffect(() => {
    if (isOpen) {
      setModalSelectedUser(selectedUser)
      setModalStartDate(startDate)
      setModalEndDate(endDate)
    }
  }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      displayCloseIcon
      animate
      style={{
        width: "min(100%, 450px)",
        height: "350px",
        padding: `${SPACING.space4} ${SPACING.space6}`,
      }}
    >
      <FlexBox
        direction="column"
        gap={SPACING.space2}
        align="flex-start"
        justify="space-between"
        style={{ height: "100%" }}
      >
        <FlexBox
          direction="column"
          align="flex-start"
          justify="flex-start"
          gap={SPACING.space2}
        >
          <Typography variant="bodyBold">{t("FRLM_FILTER_BY")}</Typography>
          <Typography variant="bodyBold">{t("FRLM_CHILD")}</Typography>
          <DropdownSelect
            type="single"
            placeholder={t("FRLM_SELECT_CHILD")}
            selectedOption={modalSelectedUser}
            setSelectedOption={setModalSelectedUser}
            options={userDropdownOptions}
            fullWidth
          />
          <DateInput
            label={t("FRLM_DATE_RANGE")}
            name="start-date"
            date={modalStartDate}
            setDate={setModalStartDate}
            maxDate={new Date()}
            modalTitle={t("FRLM_START_DATE")}
            placeholder={t("FRLM_START_DATE")}
            fullWidth
          />
          <DateInput
            name="end-date"
            date={modalEndDate}
            setDate={setModalEndDate}
            maxDate={new Date()}
            modalTitle={t("FRLM_END_DATE")}
            placeholder={t("FRLM_END_DATE")}
            fullWidth
          />
        </FlexBox>
        <Button
          buttonType="primary"
          onClick={onApplyFilter}
          text={t("FRLM_APPLY")}
          isLoading={isLoading}
          fullWidth
        />
      </FlexBox>
    </Modal>
  )
}
